import React, { FC } from 'react'
import { FIELDS } from '../../../constants/partners'
import { PartnerModalWrapper } from './partnersModalStyle'

//* components
import Button from '../../global/button'
import Modal from '../../global/modal'

type Props = {
  onClose: () => void
  open: boolean
  data: any
}

const PartnersModal: FC<Props> = ({ onClose, open, data }) => {
  if (!data) return null

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      modalTitle={'Standard Modal'}
      modalDescription={'UiPath Partner Modal'}
      handleClose={handleClose}
      open={open}>
      <div className="Modal-Fields-Container">
        <PartnerModalWrapper>
          <h3 className="Partner-Modal__Title">{data[FIELDS.NAME] || ''}</h3>
          <div
            className="Partner-Modal__Description"
            dangerouslySetInnerHTML={{ __html: data[FIELDS.DESCRIPTION] || '' }}
          />

          <Button
            icon={true}
            href={data[FIELDS.WEBSITE] || ''}
            text="Read More"
            type="text-link"
            size="small"
            target="_blank"
            rel="noopener noreferrer nofollow"
            theme="light"
          />
        </PartnerModalWrapper>
      </div>
    </Modal>
  )
}

export default PartnersModal
